import { lazy } from 'react'
import UnderMaintenance from '../../views/UnderMaintenance'
import ForgotPassword from '../../views/ForgotPassword'
import Error from '../../views/Error'
import ProductListing from '../../views/LandingPage/ProductListing'
import MainLandingPage from '../../views/LandingPage/MainLandingPage/MainLandingPage'
import { Navigate } from 'react-router-dom'
import ProductListingDetails from '../../views/LandingPage/ProductListingDetails/ProductListingDetails'
import SuccessPasswordChange from '../../views/SuccessPasswordChange'

const Login = lazy(() => import('../../views/Login'))
const Register = lazy(() => import('../../views/Register'))
// const OTP = lazy(() => import('../../views/OTP'))
// const LinkUpdate = lazy(() => import("../../views/LinkUpdate"))
const DefaultRoute = "/landingpage"


const AuthenticationRoutes = [
    {
        path: '/login',
        element: <Login />,
        meta: {
          layout: 'blank',
          publicRoute: true,
          restricted: true
        }
      },
    {
        path: '/',
        element: <Navigate replace to={DefaultRoute} />,
        index: true,
      },
      {
        path: '/under-maintenance',
        element: <UnderMaintenance />,
        meta: {
          layout: 'blank',
          publicRoute: true,
          restricted: true
        }
      },
      {
          path: "/error",
          element: <Error />,
          meta: {
          layout: "blank"
          }
      },
    // {
    //     path: "/linkUpdate",
    //     element: <LinkUpdate/>,
    //       meta: {
    //          layout: 'blank',
    //          publicRoute: true,
    //          restricted: true
    //        }
    //   },
      {
        path: "/register",
        element: <Register />,
        meta: {
          layout: "blank"
        }
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
        meta: {
          layout: "blank"
        }
      },
      {
        path: "/error",
        element: <Error />,
        meta: {
          layout: "blank"
        }
      },
      {
        path: "/product-listing",
        element: <ProductListing />,
        meta: {
            layout: 'blank',
            // publicRoute: true,
            // restricted: true
          }
      },
      {
        path: "/product-details",
        element: <ProductListingDetails />,
        meta: {
            layout: 'blank',
            // publicRoute: true,
            // restricted: true
          }
      },
      {
        path: '/reset-password-success',
        element: <SuccessPasswordChange />,
        meta: {
          layout: "blank"
        }
      },
      

    // {
    //     path: "/verification",
    //     element: <OTP />,
    //     meta: {
    //      layout: 'blank',
    //      publicRoute: true,
    //      restricted: true
    //    }
    //   },
    // {
    //   path: '/reset-password/:token/:email/:server_type',
    //   element: <ResetPasswordBasic />,
    //   meta: {
    //     layout: 'blank',
    //     publicRoute: true,
    //     restricted: true
    //   }
    // }
  ]
  
  export default AuthenticationRoutes